import React from "react"
import NavigateToVariantLink from "./navigate_to_variant_link"
import VariantSection from "./variant_section"
import styled from "@emotion/styled"
import { getVariantLabelName } from '../../helpers/emoji.js'

export default class VariantSections extends React.PureComponent {
  getVariantsArray() {
    let has_variants = false;
    const emoji = this.props.emoji;
    if (emoji.genderVariants.length > 0) {
      const gender_emoji = emoji.genderVariants[0];
      if (gender_emoji.variants.length)  {
        has_variants = true;
      }
    } else if (emoji.variants.length > 10) {
      has_variants = true;
    } else if (emoji.siblings.length > 0 && emoji.siblings[0].variants.length) {
      has_variants = true;
    }
    if (has_variants) {
      let variants_array = [[emoji]];
      let non_gender_i = 0;
      for (var i = 0; i < emoji.variants.length; i++) {
        if (!emoji.variants[i].isSkinTone) {
          non_gender_i++;  
        }
        if (!variants_array[non_gender_i]) {
          variants_array[non_gender_i] = [];
        }
        variants_array[non_gender_i].push(emoji.variants[i]);
      }
      for (var i2 = 0; i2 < emoji.genderVariants.length; i2++) {
        let g = [];
        let v = emoji.genderVariants[i2];
        g.push(v);
        for (var j = 0; j < v.variants.length; j++) {
          g.push(v.variants[j]);
        }
        variants_array.push(g);
      }
      for (var i3 = 0; i3 < emoji.siblings.length; i3++) {
        let g = [];
        let v = emoji.siblings[i3];
        g.push(v);
        for (var j2 = 0; j2 < v.variants.length; j2++) {
          g.push(v.variants[j2]);
        }
        variants_array.push(g);
      }
      if (variants_array[0].length > 6) {
        return Object.keys(variants_array[0]).map(function(c) {
          return variants_array.map(function(r) { return r[c]; });
        });
      }
      return variants_array;
    }
    return false;
  }
  getVariantList() {
    const emoji = this.props.emoji;
    let variants = [];
    for (var i = 0; i < emoji.variants.length; i++) {
      variants.push(emoji.variants[i]);
    }
    for (var i2 = 0; i2 < emoji.genderVariants.length; i2++) {
      let v = emoji.genderVariants[i2];
      variants.push(v);
      for (var j = 0; j < v.variants.length; j++) {
        variants.push(v.variants[j]);
      }
    }
    if (!variants.length && emoji.siblings.length) {
      variants.push(emoji);
      for (var i3 = 0; i3 < emoji.siblings.length; i3++) {
        variants.push(emoji.siblings[i3]);
      }  
    }
    return variants;
  }
  render() {
    const variants_array = this.getVariantsArray();
    const variant_list = this.getVariantList();
    return (
      variant_list.length && <>
        <PreviewHead className="section">
          <div className="section_inner">
            {
              <h3>
                {this.props.emoji.siblings.length === 0 ? `Variants ` : `Emojis `}
                {
                  !variants_array && variant_list.map((v, i) => {
                    return <NavigateToVariantLink key={`variant_link_${i}`} parent_emoji={this.props.emoji} emoji={v} />
                  })
                }
              </h3>
            }
            {
              variants_array &&
              <table>
                <thead>
                  <tr>
                    <td></td>
                    {
                      variants_array[0].map((c, j) => {
                        return (<th key={`variant_head_${j}`}>{j === 0 ? `default` : getVariantLabelName(this.props.emoji, c)}</th>)
                      })
                    }
                  </tr>
                </thead>
                <tbody>
                  {
                    variants_array.map((r, i) => {
                      return <tr key={`variant_row_${i}`}>{
                        r.map((c, j) => {
                          let parent = j === 0 ? this.props.emoji : r[0];
                          return <>
                              {
                                j === 0 && (<th>{getVariantLabelName(parent, c)}</th>)
                              }
                              <td><NavigateToVariantLink key={`variant_link_${i}_${j}`} parent_emoji={this.props.emoji} emoji={c} emoji_only={true} /></td>
                            </>
                        })
                      }</tr>
                    })
                  }
                </tbody>
              </table>
            }
          </div>
        </PreviewHead>
        <Sections>
          { variants_array.length && variants_array.map((r, i) => {
            return r
              // .filter((c)=>{
              //   return c.id !== this.props.emoji.id || this.props.emoji.siblings.length > 0
              // })
              .map((c, j) => {
                return <VariantSection key={`variant_section_${i}_${j}`} parent_emoji={this.props.emoji} {...this.props} emoji={c}/>
              })
          })}
          { !variants_array.length && variant_list.map((v, i) => {
            return <VariantSection key={`variant_section_${i}`} parent_emoji={this.props.emoji} {...this.props} emoji={v}/>
          })}
        </Sections>
      </>
    )
  }
}

const PreviewHead = styled("div")`
background: rgb(96, 184, 195);
table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  th {
    font-weight: normal;
    font-size: 14px;
  }
  thead {
    td {
      width: 10%;
    }
    th {
      width: 15%;
      vertical-align: top;
    }
  }
  tbody {
    th {
      text-align: left;
    }
    td {
      text-align:center;
      font-size: 36px;
      a {
        display: inline-block;
        width: 100%;
        text-decoration: none;
        :hover {
            background: white;
        }
      }
    }
  }
}
`
const Sections = styled("div")`
.section:nth-of-type(even) { background: #6DBDC9; }
`
